module.exports = __webpack_public_path__ + "static/media/flash.d21f4411.png";